import { IEntityMapObj, ITemplateType } from '../api/type-def';

export const entityDetailsMappingObj: IEntityMapObj = {
	control: {
		Frequency: 'frequency',
		Type: 'type',
		Purpose: 'purpose',
		'Key control': 'keyControl',
		'Control owner': 'controlOwner',
		Description: 'description',
		name: 'name',
		number: 'number',
		Tags: 'metadataTag',
	},
	process: {
		Industry: 'industry',
		'Covered products': 'productCount',
		name: 'processName',
		Description: 'description',
		Tags: 'tags',
	},
	policy: {
		'Policy domain': 'policyDomain',
		Type: 'type',
		Status: 'status',
		Owner: 'owner',
		Tags: 'tags',
		name: 'name',
		Description: 'description',
	},
	risk: {
		'Business unit': 'businessUnits',
		'Risk level': 'riskLevel3',
		'Risk category': 'riskCategories',
		Description: 'riskStatement',
		Tags: 'tags',
		name: 'riskName',
	},
	obligation: {
		'Issuing body': 'issuer',
		Jurisdiction: 'jurisdiction',
		'Assigned to': 'assignedUserName',
		'Due date': 'reviewByDate',
		'Business unit': 'businessUnits',
		Description: 'summary',
		name: 'groupName',
	},
};

export const entityProcessDetailsFormat: ITemplateType[] = [
	{
		label: 'name',
		value: 'NA',
	},
	{
		label: 'Industry',
		value: 'NA',
	},
	{
		label: 'Covered products',
		value: 'NA',
	},
	{
		label: 'Description',
		value: 'NA',
	},
	{
		label: 'Tags',
		value: 'NA',
	},
];

export const entityControlDetailsFormat: ITemplateType[] = [
	{
		label: 'Frequency',
		value: 'NA',
	},
	{
		label: 'Type',
		value: 'NA',
	},
	{
		label: 'Purpose',
		value: 'NA',
	},
	{
		label: 'Key control',
		value: 'NA',
	},
	{
		label: 'Control owner',
		value: 'NA',
	},
	{
		label: 'Description',
		value: 'NA',
	},
	{
		label: 'number',
		value: '',
	},
	{
		label: 'name',
		value: 'NA',
	},
	{
		label: 'Tags',
		value: 'NA',
	},
];

export const entityPolicyDetailsFormat: ITemplateType[] = [
	{
		label: 'Policy domain',
		value: 'NA',
	},
	{
		label: 'Type',
		value: 'NA',
	},
	{
		label: 'Status',
		value: 'NA',
	},
	{
		label: 'Owner',
		value: 'NA',
	},
	{
		label: 'Description',
		value: 'NA',
	},
	{
		label: 'Tags',
		value: 'NA',
	},
	{
		label: 'name',
		value: 'NA',
	},
];

export const entityRiskDetailsFormat: ITemplateType[] = [
	{
		label: 'Business unit',
		value: 'NA',
	},
	{
		label: 'Risk level',
		value: 'NA',
	},
	{
		label: 'Risk category',
		value: 'NA',
	},
	{
		label: 'Description',
		value: 'NA',
	},
	{
		label: 'Tags',
		value: 'NA',
	},
	{
		label: 'name',
		value: 'NA',
	},
];

export const entityObligationDetailsFormat: ITemplateType[] = [
	{
		label: 'Issuing body',
		value: 'NA',
	},
	{
		label: 'Jurisdiction',
		value: 'NA',
	},
	{
		label: 'Assigned to',
		value: 'NA',
	},
	{
		label: 'Due date',
		value: 'NA',
	},
	{
		label: 'Business unit',
		value: 'NA',
	},
	{
		label: 'Description',
		value: 'NA',
	},
	{
		label: 'name',
		value: 'NA',
	},
];
